import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialSection = ({ testimonials }) => {
  return (
    <div className="bg-card rounded-lg shadow-md p-4 md:p-5 lg:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-5 lg:mb-6">
        <Icon name="Quote" size={20} color="var(--color-primary)" />
        <h3 className="text-base md:text-lg lg:text-xl font-heading font-semibold text-foreground">
          Student Testimonials
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        {testimonials?.map((testimonial) => (
          <div
            key={testimonial?.id}
            className="p-4 md:p-5 bg-muted rounded-lg hover:bg-muted/80 transition-smooth"
          >
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full overflow-hidden flex-shrink-0">
                <Image
                  src={testimonial?.avatar}
                  alt={testimonial?.avatarAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm md:text-base font-semibold text-foreground">
                  {testimonial?.name}
                </h4>
                <p className="text-xs text-muted-foreground">
                  {testimonial?.program} • Class of {testimonial?.year}
                </p>
              </div>
              <div className="flex gap-0.5">
                {[...Array(5)]?.map((_, i) => (
                  <Icon
                    key={i}
                    name={i < testimonial?.rating ? 'Star' : 'Star'}
                    size={14}
                    color={i < testimonial?.rating ? 'var(--color-warning)' : 'var(--color-muted-foreground)'}
                    className={i < testimonial?.rating ? 'fill-current' : ''}
                  />
                ))}
              </div>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed line-clamp-4">
              {testimonial?.content}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialSection;